module.exports = {"540221100":"南木林镇","540221200":"普当乡","540221201":"仁堆乡","540221202":"拉布普乡","540221203":"多角乡","540221204":"卡孜乡","540221205":"土布加乡","540221206":"艾玛乡","540221207":"奴玛乡","540221208":"达孜乡","540221209":"索金乡","540221210":"茶尔乡","540221211":"秋木乡","540221212":"达那乡","540221213":"芒热乡","540221214":"热当乡","540221215":"甲措乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540221.json
// module id = 2492
// module chunks = 0